import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { pageMeta, useDocumentMeta } from '../hooks/useDocumentMeta';
export function NotFound() {
  useDocumentMeta(pageMeta.notFound);
  return <section className="relative overflow-hidden bg-ink py-24 lg:py-32" data-id="element-376" data-mp="104bdaxk01s7w">
      <div className="absolute inset-0 bp opacity-80" aria-hidden="true" data-id="element-377" data-mp="1557o7v2rqemt" />

      <div className="relative mx-auto max-w-8xl px-5 sm:px-8 lg:px-10" data-id="element-378" data-mp="1a4aiqll4h2gj">
        <p className="font-mono text-[11.5px] uppercase tracking-[0.18em] text-forge-cyan" data-id="element-379" data-mp="1a27x0dr05vhm">Page not found</p>
        <h1 className="mt-3 max-w-2xl font-display text-[2rem] font-extrabold leading-[1.1] tracking-[-0.02em] text-white sm:text-[2.5rem]" data-id="element-380" data-mp="1jtu54181neg5">
          We couldn&apos;t find that page.
        </h1>
        <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-mist-200" data-id="element-381" data-mp="1nxa2x0vunkuf">
          The address may have changed. Start from the homepage, or tell us what you were looking for.
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-382" data-mp="1xra9z8aoz05s">
          <Link to="/" className="inline-flex items-center justify-center rounded-xl bg-forge-orange px-6 py-3.5 text-[15px] font-bold text-ink" data-id="element-383" data-mp="1nxf34mg4tiz8">
            Back to home
          </Link>
          <Link to="/#get-started" className="group inline-flex items-center justify-center gap-2 rounded-xl border border-white/18 px-6 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-white/5" data-id="element-384" data-mp="1ex9wieiriom4">
            Discuss Your Project
            <ArrowRightIcon className="h-4 w-4 text-forge-orange transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-385" data-mp="22ljnduuu22k4" />
          </Link>
        </div>
      </div>
    </section>;
}